module.exports = __webpack_public_path__ + "img/画板 18.dea90326.jpg";